<template>
  <div class="page-template combination-page" v-loading="loading">
    <el-tabs v-model="activeName" @tab-click="tabClick">
      <el-tab-pane label="商品组合" name="first">
        <search-form-template
          :searchOptions="combinationSearchOptions"
          @searchSubmit="combinationSearchSubmit"
          @clear="clearSearch('combination')"
          :toolConfig="combinationToolConfig"
          @btnCommon="btnCommon"
        ></search-form-template>
        <table-template v-if="activeName === 'first'" ref="combinationTable" :tableOptions="combinationTable"
                        :toolConfig="combinationToolConfig1" @rowClick="rowClick"></table-template>
        <div class="title-combination">
          <span class="title-circle"></span>
          <span>成份信息</span>
        </div>
        <!--商品组合子商品列表-->
        <list-template v-if="activeName === 'first'" class="childrenShow" ref="listTemplates" :tableData="childrenTable"
                       :tableOptions="childrenOptions"></list-template>
      </el-tab-pane>
      <el-tab-pane label="大小包装" name="second">
        <search-form-template
          :searchOptions="packSearchOptions"
          @searchSubmit="packSearchSubmit"
          @clear="clearSearch('pack')"
          :toolConfig="packToolConfig"
          @btnCommon="btnCommon"
        ></search-form-template>
        <table-template v-if="activeName === 'second'" ref="packTable" :tableOptions="packTable"
                        :toolConfig="packToolConfig1" @rowClick="rowClick"></table-template>
        <div class="title-combination">
          <span class="title-circle"></span>
          <span>成份信息</span>
        </div>
        <!--大小包装子商品列表-->
        <list-template v-if="activeName === 'second'" class="childrenShow" ref="listTemplates"
                       :tableData="childrenTable" :tableOptions="childrenOptions"></list-template>
      </el-tab-pane>
      <el-tab-pane label="自动转货" name="third">
        <search-form-template
          :searchOptions="combinationSearchOptions"
          @searchSubmit="TransferSearchSubmit"
          @clear="clearSearch('Transfer')"
          :toolConfig="TransferToolConfig"
          @btnCommon="btnCommon"
        ></search-form-template>
        <table-template v-if="activeName === 'third'" ref="TransferTable" :tableOptions="TransferTable"
                        :toolConfig="TransferToolConfig1" @rowClick="rowClick"></table-template>
        <div class="title-combination">
          <span class="title-circle"></span>
          <span>成份信息</span>
        </div>
        <list-template v-if="activeName === 'third'" class="childrenShow" ref="listTemplates" :tableData="childrenTable"
                       :tableOptions="childrenOptions"></list-template>
      </el-tab-pane>
    </el-tabs>

    <!--新增商品组合弹框-->
    <el-dialog
      :title="dialogTitle"
      @closed="clearData"
      :visible.sync="dialogVisibility"
      center
      custom-class="category-dialog"
      width="900px"
      height="800"
    >
      <div class="column-title" v-show="activeName=='first'">组合类型</div>
      <div class="type-box" v-show="activeName=='first'">
        <div
          class="type-item"
          :class="{'active':combinationModel.type == typeItem.value,'disabled':combinationModel.id}"
          v-for="typeItem in combinationType"
          :key="typeItem.title"
          @click="typeChange(typeItem.value)"
        >
          <div class="type-title">{{ typeItem.title }}</div>
          <div v-for="sub in typeItem.subtitle" :key="sub">{{ sub }}</div>
          <div></div>
        </div>
      </div>
      <div class="column-title">主商品</div>
      <div class="com-item">
        <el-button type="primary" @click="showGoodsList" v-show="!combinationModel.id">选择主商品</el-button>
      </div>
      <div class="com-item">
        <list-template v-if="dialogVisibility" :tableData="fatherVo" :tableOptions="listColumns"></list-template>
      </div>
      <div class="column-title">子商品</div>
      <div class="com-item">
        <list-operation v-if="dialogVisibility" ref="listOperation" :tableOptions="sonListColumns"></list-operation>
      </div>
      <div class="btn-box">
        <el-button type="primary" @click="submitData">提交</el-button>
      </div>
    </el-dialog>
    <!--选择商品弹框-->
    <el-dialog
      title="商品列表"
      :visible.sync="listShow"
      width="1200px"
      :modal="false"
      custom-class="participation-dialog"
      :close-on-click-modal="false"
    >
      <good-list
        v-if="listShow"
        ref="goodsListOperation"
        :isSelect="listType=='sonVoList'&& (activeName == 'first' || activeName == 'third' )"
        @selectSubmit="rowsSelectSubmit"
        @rowCheck="rowSelectSubmit"
        :otherParam="otherParam"
        :seleckMainGood='seleckMainGood'
        :listTableData="listTableData"
      ></good-list>
    </el-dialog>
    <!-- 一键同步弹窗 -->
    <el-dialog
      title="一键同步"
      :visible.sync="synchronizedShow"
      width="640px"
      :modal="true"
      center
      @close="handleDialogClose"
      :close-on-click-modal="false"
      custom-class="synchronized"
    >
      <div v-if="!showDetail" style="padding:36px 65px;">
        <el-steps :active="currentStep" align-center class="cus-steps">
          <el-step title="选择门店"></el-step>
          <el-step title="同步数据"></el-step>
          <el-step title="同步完成"></el-step>
        </el-steps>
        <div v-if="currentStep < 1" style="font-size: 14px;color: #333333;margin-top:43px;">
          <span>将总部现有{{ combWord }}关系同步给：</span>
          <el-select v-model="synchronizedValue" @change="changeSelect" placeholder="请选择">
            <el-option
              v-for="item in shopList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div v-if="currentStep == 1" style="text-align: center;padding-bottom:40px;margin-top:90px;">
          <i style="font-size: 48px" class="el-icon-loading"></i>
          <div style="font-size: 16px;font-family: Microsoft YaHei;font-weight: 300;color: #999999;margin-top:12px;">
            正在同步
          </div>
        </div>
        <!-- 有问题按键-->
        <el-button v-if="currentStep == 3 && operationRecordId" type="primary"
                   style="width: 100%;height:40px;margin-top:50px;"
                   @click.prevent="showDetail = true; getResult(operationRecordId)">查看详情
        </el-button>
        <div v-if="currentStep == 3 && !operationRecordId && !importStatus"
             style="text-align: center;margin-top: 80px;padding-bottom: 40px;">
          <div>
            <i style="font-size: 64px;color:#FF553E" class="el-icon-circle-close"></i>
          </div>
          <span style="margin-top:12px;color:#FF553E;">同步结束</span>
        </div>
        <div v-if="currentStep == 3 && importStatus" style="text-align: center;margin-top: 80px;padding-bottom: 40px;">
          <div>
            <i style="font-size: 64px;color:#458CFF" class="el-icon-circle-check"></i>
          </div>
          <span style="margin-top:12px;">同步成功！</span>
        </div>
        <!-- 第一页信息-->
        <div style="margin-top:42px;" v-if="currentStep < 1">
          <div>温馨提示：</div>
          <div style="margin-top:17px;">1、请先进行商品信息同步，门店不存在的商品将无法同步{{ combWord }}关系</div>
          <div style="margin-top:17px;">2、同步至门店预计要3分钟，请3分钟后进入门店查看同步状态</div>
        </div>
        <div v-if="currentStep < 1" style="margin-top:48px;">
          <el-button
            type="primary"
            @click="goSynchronized"
            style="width: 508px;border-radius: 4px;background: #458CFF;height:40px;"
          >立即同步
          </el-button>
        </div>
      </div>
      <div v-else style="padding: 30px">
        <div
          style="margin-bottom:27px;padding:11px 14px;font-weight: 300;color: #FF553E; width: 100%;background: #FFF6F4;border-radius: 4px;">
          <i class="el-icon-circle-close"></i>
          同步失败{{ errorCount }}条商品
        </div>
        <el-table :data="errorData" :cell-style="{height:'40px' }" :header-cell-style="{height: '40px'}">
          <el-table-column label="序号" type="index" width="75" :index="(index) => { return index + 1}"
                           align="center"></el-table-column>
          <el-table-column label="条码" width="150" align="center" prop="barCode"></el-table-column>
          <el-table-column label="异常原因" width="330" align="center" prop="remarks"></el-table-column>
        </el-table>
        <el-pagination
          background
          :page-size="10"
          :current-page="errPageNo"
          @current-change="(val) =>{getResult({pageNumber: val })}"
          layout="prev, pager, next"
          :total="errorCount">
        </el-pagination>
      </div>
    </el-dialog>
    <!-- 导入弹窗 -->
    <el-dialog title="批量导入" :visible.sync="importShow"
               @close="currentStep = 0;showDetail = false;operationRecordId = '';" :close-on-click-modal="false"
               custom-class="importDialog">
      <div style="padding:30px 66px;" v-if="!showDetail">
        <el-steps :active="currentStep" align-center style="padding-bottom:20px" class="cus-steps">
          <el-step title="上传数据"></el-step>
          <el-step title="导入数据"></el-step>
          <el-step title="导入完成"></el-step>
        </el-steps>
        <el-button v-if="currentStep < 1" type="primary" style="width: 100%;height:40px;margin-top:50px;"
                   :loading="currentStep !== 0 && currentStep !== 3" @click.prevent="importFile">立即导入
        </el-button>
        <div v-if="currentStep == 1" style="text-align: center;padding-bottom:40px;margin-top:90px;">
          <i style="font-size: 48px" class="el-icon-loading"></i>
          <div style="font-size: 16px;font-family: Microsoft YaHei;font-weight: 300;color: #999999;margin-top:12px;">
            正在导入
          </div>
        </div>
        <!-- 有问题按键-->
        <el-button v-if="currentStep == 3 && operationRecordId" type="primary"
                   style="width: 100%;height:40px;margin-top:50px;"
                   @click.prevent="showDetail = true; getResult(operationRecordId)">查看详情
        </el-button>
        <div v-if="currentStep == 3 && !operationRecordId && !importStatus"
             style="text-align: center;margin-top: 80px;padding-bottom: 40px;">
          <div>
            <i style="font-size: 64px;color:#FF553E" class="el-icon-circle-close"></i>
          </div>
          <span style="margin-top:12px;color:#FF553E;">导入结束</span>
        </div>
        <div v-if="currentStep == 3 && importStatus" style="text-align: center;margin-top: 80px;padding-bottom: 40px;">
          <div>
            <i style="font-size: 64px;color:#458CFF" class="el-icon-circle-check"></i>
          </div>
          <span style="margin-top:12px;">导入成功！</span>
        </div>
        <!-- 第一页显示 -->
        <div v-if="currentStep < 1"
             style="color: #2A2A2A;font-size: 16px;font-weight: 300;margin-top:47px;text-align: left">
          <div style="margin-bottom: 17px;">温馨提示:</div>
          <div>1、如果您还没有下载导入模板，请下载 <span @click.prevent="downLoadModel"
                                        style="cursor: pointer; color:#458CFF; text-decoration: underline;">{{
              combWord
            }}导入模板</span></div>
          <div style="margin-top: 14px;">2、单次可导入2000条以内的数据</div>
          <!--          <div style="margin-top:14px;">3、导入完成后成功同步到门店预计要3分钟，请3分钟后进入门店查看同-->
          <!--            步状态</div>-->
        </div>
      </div>
      <div v-else style="padding: 30px">
        <div
          style="margin-bottom:27px;padding:11px 14px;font-weight: 300;color: #FF553E; width: 100%;background: #FFF6F4;border-radius: 4px;">
          <i class="el-icon-circle-close"></i>
          导入失败{{ errorCount }}条商品
        </div>
        <el-table :data="errorData" :cell-style="{height:'40px' }" :header-cell-style="{height: '40px'}">
          <el-table-column label="序号" type="index" width="75" :index="(index) => { return index + 1}"
                           align="center"></el-table-column>
          <el-table-column label="条码" width="150" align="center" prop="barCode"></el-table-column>
          <el-table-column label="异常原因" width="330" align="center" prop="remarks"></el-table-column>
        </el-table>
        <el-pagination
          background
          :page-size="10"
          :current-page="errPageNo"
          @current-change="(val) =>{getResult({pageNumber: val })}"
          layout="prev, pager, next"
          :total="errorCount">
        </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import api from '@/config/api'; // 商品列表组件
  import goodList from '@/components/business/goodList';
  // 添加要货单组件
  import listOperation from '@/components/template/listOperation';
  import listTemplate from '@/components/template/listTemplate';

  export default {
    components: {goodList, listOperation, listTemplate},
    data() {
      return {
        errorData: [],
        errorCount: 0,
        barCodeTotal: 0,
        errPageNo: 1,
        importStatus: false,
        showDetail: false,
        operationRecordId: '',
        currentStep: 0,
        childrenTable: [],
        listTableData: [],
        combWord: '大小包装',
        seleckMainGood: {},
        sonList: [],
        sonListShow: false,
        otherParam: {},
        dialogTitle: '',
        combinationType: [
          // {
          //   title: "制单组合",
          //   subtitle: ["1.烟酒超市烟的销售", "2.超市牛奶的销售"],
          //   value: 10,
          // },
          {
            title: '捆绑商品',
            subtitle: ['1.促销销售', '2.捆绑销售'],
            value: 20
          }
        ],
        loading: false,
        title: '',
        activeName: 'first',
        nowSonList: [],
        combinationSearchOptions: {
          simple: [
            {
              label: '商品名称',
              prop: 'otherName',
              type: 'input',
              isFuzzy: true,
              placeholder: '请输入商品名称或条码'
            }
            // {
            //   label: "商品条码",
            //   prop: "barcode",
            //   type: "input",
            //   isFuzzy: true,
            //   placeholder: "请输入商品条码",
            // },
          ]
        },
        packSearchOptions: {
          simple: [
            {
              label: '商品名称',
              prop: 'otherName',
              type: 'input',
              isFuzzy: true,
              placeholder: '请输入商品名称或条码'
            }
            // {
            //   label: "商品条码",
            //   prop: "barcode",
            //   type: "input",
            //   isFuzzy: true,
            //   placeholder: "请输入商品条码",
            // },
          ]
        },
        combinationToolConfig: [
          {
            label: '添加',
            code: 'insertCombination',
            callback: this.addCombination
          }
          // {
          //   label: '导入',
          //   code: 'importSyncExcel',
          //   callback: this.importSyncExcel
          // },
          // {
          //   label: '一键同步',
          //   code: 'synchronized',
          //   callback: this.setSynchronized
          // }
        ],
        synchronizedShow: false,
        importShow: false,
        synchronizedTarget: '',
        synchronizedValue: '',
        shopList: [],
        combinationToolConfig1: [
          {
            label: '编辑',
            code: 'update',
            more: true,
            type: this.$utils.buttonType.tableOperate,
            callback: this.updateCombination
          },
          {
            label: '删除',
            more: true,
            type: this.$utils.buttonType.tableOperate,
            code: 'delete',
            deleteUrl: api.archives.combination,
            // filter: () => {
            //   return false
            // }
          }
        ],
        TransferToolConfig: [
          {
            label: '添加',
            code: 'insertCombination',
            callback: this.addTransfer
          },
          {
            label: '导入',
            code: 'importSyncExcel',
            callback: this.importSyncExcel
          },
          {
            label: '一键同步',
            code: 'synchronized',
            callback: this.setSynchronized
          }
        ],
        TransferToolConfig1: [
          {
            label: '编辑',
            code: 'update',
            more: true,
            type: this.$utils.buttonType.tableOperate,
            callback: this.updateCombination
          },
          {
            label: '删除',
            more: true,
            type: this.$utils.buttonType.tableOperate,
            code: 'delete',
            deleteUrl: api.archives.combination,
            // filter: () => {
            //   return false
            // }
          }
        ],
        // 商品组合 列表配置
        combinationTable: {
          tableName: 'combinationTable',
          height: '198',
          indexShow: true, // 是否显示索引
          isRowClick: true, // 是否开启单击某行效果
          rowClickUrl: api.archives.combinationSonList,
          columns: [
            {
              label: '条码',
              prop: 'barCode',
              width: '150',
              align: 'center'
            },
            {
              label: '商品名称',
              prop: 'goodsName',
              width: '200',
              align: 'center'
            },
            // {
            //   label: "主商品",
            //   prop: "goodsName",
            //   width: "200",
            //   deal: this.fatherName,
            //   align: "center",
            // },
            {
              label: '组合类型',
              prop: 'typeDesc',
              width: '150',
              align: 'center'
            },
            {
              label: '单位',
              prop: 'unitName',
              width: '100',
              align: 'center'
            },
            {
              label: '进价',
              prop: 'buyPrice',
              width: '100',
              align: 'center'
            },
            // {
            //   label: "子商品",
            //   prop: "sonGoodsName",
            //   width: "150",
            //   align: "center",
            //   deal: this.sonName,
            //   callback: this.showSonList,
            // },
            {
              label: '组合时间',
              prop: 'lastModifyDttm',
              width: '200',
              align: 'center'
            }
          ],
          url: api.archives.combinationPage,
          param: {combinationType: 10}
        },
        // 自动转货 列表
        TransferTable: {
          tableName: 'TransferTable',
          height: '198',
          indexShow: true, // 是否显示索引
          isRowClick: true, // 是否开启单击某行效果
          rowClickUrl: api.archives.combinationSonList,
          columns: [
            {
              label: '条码',
              prop: 'barCode',
              width: '150',
              align: 'center'
            },
            {
              label: '商品名称',
              prop: 'goodsName',
              width: '200',
              align: 'center'
            },
            {
              label: '单位',
              prop: 'unitName',
              width: '100',
              align: 'center'
            },
            {
              label: '进价',
              prop: 'buyPrice',
              width: '100',
              align: 'center'
            },
            {
              label: '组合时间',
              prop: 'lastModifyDttm',
              width: '200',
              align: 'center'
            }
          ],
          url: api.archives.combinationPage,
          param: {combinationType: 30}// 10商品组合 20大小包装 30自动转货
        },
        // 大小包装列表配置
        packTable: {
          tableName: 'packTable',
          height: '231',
          indexShow: true, // 是否显示索引
          isRowClick: true, // 是否开启单击某行效果
          rowClickUrl: api.archives.combinationSonList,
          columns: [
            {
              label: '条码',
              prop: 'barCode',
              width: '200',
              align: 'center'
            },
            {
              label: '主商品名称',
              prop: 'goodsName',
              width: '200',
              align: 'center'
            },
            // {
            //   label: "小包装",
            //   prop: "sonGoodsName",
            //   width: "100",
            //   align: "center",
            //   deal: this.sonName,
            //   callback: this.showSonList,
            // },
            {
              label: '单位',
              prop: 'unitName',
              width: '200',
              align: 'center'
            },
            {
              label: '进货价',
              prop: 'buyPrice',
              width: '200',
              align: 'center'
            },
            {
              label: '包装时间',
              prop: 'lastModifyDttm',
              width: '200',
              align: 'center'
            }
          ],
          url: api.archives.combinationPage,
          param: {combinationType: 20}
        },
        packToolConfig: [
          {
            label: '添加',
            code: 'insertPack',
            callback: this.addPack
          },
          {
            label: '导入',
            code: 'importSyncExcel',
            callback: this.importSyncExcel
          },
          {
            label: '一键同步',
            code: 'synchronized',
            callback: this.setSynchronized
          }
        ],
        packToolConfig1: [
          {
            label: '编辑',
            code: 'update',
            more: true,
            type: this.$utils.buttonType.tableOperate,
            callback: this.updatePack
          },
          {
            label: '删除',
            more: true,
            type: this.$utils.buttonType.tableOperate,
            code: 'delete',
            deleteUrl: api.archives.combination,
            // filter: () => {
            //   return false
            // }
          }
        ],
        listColumns: {
          columns: [
            {
              label: '条码',
              prop: 'barCode'
            },
            {
              label: '商品名称',
              prop: 'goodsName',
              width: '100'
            },
            {
              label: '规格',
              prop: 'specs',
              width: '100'
            },
            {
              label: '单位',
              prop: 'unitName',
              width: '100'
            },
            {
              label: '进货价',
              prop: 'buyPrice',
              width: '150',
              align: 'center'
            },
            {
              label: '零售价',
              prop: 'retailPrice',
              width: '200',
              align: 'center'
            },
            {
              label: '成分数量',
              prop: 'goodsNum',
              width: 200,
              align: 'center'
            }
          ]
        },
        childrenOptions: {
          disabled: false,
          height: '210',
          // showSummary:true,
          indexShow: true, // 是否显示索引
          // summaryColumns: ['goodsNum', 'totalPrice'],
          summaryColumns: ['totalPrice'],
          columns: [
            {
              label: '条码',
              prop: 'barCode',
              align: 'center'
            },
            {
              label: '商品名称',
              prop: 'goodsName',
              width: '100',
              align: 'center'
            },
            {
              label: '单位',
              prop: 'unitName',
              width: '100',
              align: 'center'
            },
            {
              label: '进货价',
              prop: 'buyPrice',
              width: '100',
              align: 'center'
            },
            {
              label: '商品数量',
              prop: 'goodsNum',
              width: '100',
              align: 'center'
            },
            {
              label: '金额小计',
              prop: 'totalPrice',
              width: '100',
              align: 'center',
              precision: 2
            }
          ]
        },
        sonListColumns: {
          // summaryColumns: ['goodsNum', 'totalPrice', 'buyPrice'],
          summaryColumns: ['goodsNum', 'totalPrice'],
          hideSum: true,
          disabled: false,
          indexShow: true, // 是否显示索引
          columns: []
        },
        detailColumns: [
          {
            label: '条码',
            prop: 'barCode'
          },
          {
            label: '商品名称',
            prop: 'goodsName',
            width: '100'
          },
          {
            label: '规格',
            prop: 'specs',
            width: '100'
          },
          {
            label: '单位',
            prop: 'unitName',
            width: '100'
          },
          {
            label: '进货价',
            prop: 'buyPrice',
            width: '100'
          },
          {
            label: '成分数量',
            prop: 'goodsNum',
            width: '100'
          },
          {
            label: '金额小计',
            prop: 'totalPrice',
            width: '100',
            precision: 2
          }
        ],
        // 大小包装子商品
        bigColumns: [
          {
            label: '选择商品',
            prop: 'selectGoods',
            type: 'more',
            callback: this.showSonGoodsList,
            width: '90'
          },
          {
            label: '条码',
            prop: 'barCode',
            type: 'input',
            change: this.queryGoodsByBarCode,
            width: '120'
          },
          {
            label: '商品名称',
            prop: 'goodsName',
            width: '100'
          },
          {
            label: '规格',
            prop: 'specs',
            width: '80'
          },
          {
            label: '单位',
            prop: 'unitName',
            width: '80'
          },
          {
            label: '进货价',
            prop: 'buyPrice',
            width: '100'
          },
          {
            label: '成分数量',
            prop: 'goodsNum',
            width: '100',
            type: 'inputNumber',
            precision: 3,
            max: 9999.999,
            defaultValue: 1,
            change: this.numChange
          },
          {
            label: '金额小计',
            prop: 'totalPrice',
            width: '100',
            type: 'inputNumber',
            disabled: true,
            precision: 2,
            defaultValue: 1,
            defaultChange: this.getTotalPrice
          }
        ],
        // 组合商品/自动转货 子商品
        goodsColumns: [
          {label: '操作', type: 'operation', width: 100, prop: 'operation'},
          {
            label: '选择商品',
            prop: 'selectGoods',
            type: 'more',
            callback: this.showSonGoodsList,
            width: '90'
          },
          {
            label: '条码',
            prop: 'barCode',
            type: 'input',
            change: this.queryGoodsByBarCode,
            width: '120'
          },
          {
            label: '商品名称',
            prop: 'goodsName',
            width: '100'
          },
          {
            label: '规格',
            prop: 'specs',
            width: '80'
          },
          {
            label: '单位',
            prop: 'unitName',
            width: '80'
          },
          {
            label: '进货价',
            prop: 'buyPrice',
            width: '100'
          },
          {
            label: '成分数量',
            prop: 'goodsNum',
            width: '100',
            type: 'inputNumber',
            precision: 3,
            max: 9999.999,
            defaultValue: 1,
            change: this.numChange
          },
          {
            label: '金额小计',
            prop: 'totalPrice',
            width: '100',
            type: 'inputNumber',
            disabled: true,
            precision: 2,
            defaultChange: this.getTotalPrice
          }
        ],
        selectRow: {},
        fatherVo: [],
        listType: '',
        listShow: false,
        dialogVisibility: false,
        combinationModel: {
          type: 10,
          fatherVo: {},
          sonVoList: [],
          combinationType: 10
        }
      };
    },
    created() {
      const UserInfo = JSON.parse(localStorage.getItem('SYSUSER'))
      this.merchantId = UserInfo.merchantId
      this.title = document.title;
    },
    methods: {
      getResult({operationRecordId = this.operationRecordId, pageNumber = this.errPageNo, pageSize = 10}) {
        const param =
          {
            pageNumber,
            pageSize,
            operationRecordId
          }
        this.$axios.fetchPost(api.archives.getErrorReason, param).then(res => {
          console.log(res)
          this.errorData = res.data.records
          this.errorCount = res.data.total;
        })
      },
      handleDialogClose() {
        this.synchronizedValue = ''
        this.currentStep = 0;
        this.showDetail = false;
        this.operationRecordId = '';
      },
      goSynchronized() {
        this.importStatus = false; // 初始化
        if (this.combWord === '大小包装') {
          const param = {
            merchantId: this.merchantId,
            storeId: this.synchronizedValue
          }
          this.currentStep = 1
          this.$axios.fetchPost(api.archives.syncPacking, param).then(data => {
            console.log(data)
            this.currentStep = 2;
            if (data.code === 200) {
              this.operationRecordId = data.data
              this.importStatus = true
              // return this.$message({message: '同步成功!', type: 'success'})
              this.$notify({
                type: "success",
                title: '同步操作',
                message: '成功',
                showClose: false,
              });
            } else {
              if (data.errorMsg) {
                return this.$message({message: data.errorMsg, type: 'warning'});
              } else {
                return this.$message({message: '同步异常', type: 'error'});
              }
            }
          }).finally(() => {
            this.currentStep = 3
          })
        }

        if (this.combWord === '自动转货') {
          const param = {
            storeId: this.synchronizedValue
          }
          this.$axios.fetchPost(api.archives.syncTrans, param).then(data => {
            this.currentStep = 2;
            if (data.code === 200) {
              this.operationRecordId = data.data
              this.importStatus = true
              this.$notify({
                type: "success",
                title: '同步操作',
                message: '成功',
                showClose: false,
              });
              // return this.$message({message: '同步成功!', type: 'success'})
            } else {
              if (data.errorMsg) {
                return this.$message({message: data.errorMsg, type: 'warning'});
              } else {
                return this.$message({message: '同步异常', type: 'error'});
              }
            }
          }).finally(() => {
            this.currentStep = 3
          })
        }
      },
      // 判断文件类型
      isExcellType(ext) {
        return ['xls', 'xlsx'].indexOf(ext.toLowerCase()) !== -1;
      },
      // 导入
      importFile() {
        this.$confirm('只能上传.xls/.xlsx文件')
          .then(_ => {
            this.$utils.uploadFile((file) => {
              console.log(file)
              this.currentStep = 1;
              this.importStatus = false
              let formData = new FormData();
              formData.append('file', file);
              let index = file.name.lastIndexOf('.');
              let ext = file.name.substr(index + 1);
              if (!this.isExcellType(ext)) {
                this.$message.warning('只能上传.xls/.xlsx文件!')
                this.currentStep = 0
              } else {
                if (this.combWord === '大小包装') {
                  this.$axios
                    .fetchPostGoodsExport(api.archives.importPackaging, formData)
                    .then(data => {
                      console.log(data)
                      this.currentStep = 2;
                      this.operationRecordId = data.data
                      if (data.code === 200) {
                        this.importStatus = true
                        this.$notify({
                          type: "success",
                          title: '导入操作',
                          message: '成功',
                          showClose: false,
                        });
                        // return this.$message({message: '导入成功!', type: 'success'})
                      } else {
                        if (data.errorMsg) {
                          return this.$message({message: data.errorMsg, type: 'warning'});
                        } else {
                          return this.$message({message: '导入异常', type: 'error'});
                        }
                      }
                    }).catch((err) => {
                    console.lg(err)
                  }).finally(() => {
                    this.currentStep = 3
                  });
                }
                if (this.combWord === '自动转货') {
                  this.$axios
                    .fetchPostGoodsExport(api.archives.importTransfer, formData)
                    .then(data => {
                      console.log(data)
                      this.currentStep = 2;
                      if (data.code === 200) {
                        this.operationRecordId = data.data
                        this.importStatus = true
                        console.log(this.operationRecordId)
                        this.$notify({
                          type: "success",
                          title: '导入操作',
                          message: '成功',
                          showClose: false,
                        });
                        // return this.$message({message: '导入成功!', type: 'success'})
                      } else {
                        if (data.errorMsg) {
                          return this.$message({message: data.errorMsg, type: 'warning'});
                        } else {
                          return this.$message({message: '导入异常', type: 'error'});
                        }
                      }
                    }).catch((err) => {
                    console.lg(err)
                  }).finally(() => {
                    this.currentStep = 3
                  });
                }
              }
            });
          }).catch(() => {
          this.showUpload = false
          this.currentStep = 0
        })
      },
      downLoadModel() {
        if (this.combWord === '大小包装') return this.downLoadPackagingModel()
        if (this.combWord === '自动转货') return this.downLoadTransModel()
      },
      // 一件同步
      setSynchronized() {
        // console.log(this.activeName)
        if (this.activeName === 'first') {
          this.combWord = '商品组合'
        } else if (this.activeName === 'second') {
          this.combWord = '大小包装'
        } else if (this.activeName === 'third') {
          this.combWord = '自动转货'
        }
        this.synchronizedShow = true
        this.getShowList()
      },
      getShowList() {
        this.$axios.fetchPost(api.archives.shopColumn).then(res => {
          console.log(res)
          if (res.code === 200) {
            this.shopList = res.data
          }
        })
      },
      changeSelect(val) {
        console.log(val)
        console.log(this.synchronizedValue)
      },
      downLoadPackagingModel(val) {
        this.$axios.fetchPost(api.archives.downLoadPackaging).then(data => {
          if (data.code === 200) {
            const elink = document.createElement('a');
            elink.href = data.data;
            elink.click();
          } else {
            this.$message({message: data.errorMsg, type: 'error'});
          }
        });
      },
      downLoadTransModel(val) {
        this.$axios.fetchPost(api.archives.downLoadTransModel).then(data => {
          if (data.code === 200) {
            const elink = document.createElement('a');
            elink.href = data.data;
            elink.click();
          } else {
            this.$message({message: data.errorMsg, type: 'error'});
          }
        });
      },
      importSyncExcel() {
        console.log(this.activeName)
        if (this.activeName === 'first') {
          this.combWord = '商品组合'
        } else if (this.activeName === 'second') {
          this.combWord = '大小包装'
        } else if (this.activeName === 'third') {
          this.combWord = '自动转货'
        }
        this.importShow = true
      },
      // 切换tabs
      tabClick() {
        this.childrenTable = []
      },
      // 点击某行，展示子商品列表
      rowClick(row, rfName) {
        this.$refs[rfName].setCurrentRow(rfName)
        this.$refs[rfName].setCurrentRow(rfName, row)
        this.$axios.fetchPost(api.archives.combinationSonList, {combinationId: row.id}).then((res) => {
          if (res.code == 200 && res.data) {
            this.childrenTable = res.data
          } else {
            this.$message({message: '获取成分出错：' + '[' + res.code + ']' + res.errorMsg, type: 'error'});
            this.childrenTable = []
          }
        });
      },
      // showSonList(row) {
      //   this.$axios
      //     .fetchPost(api.archives.combinationSonList + "?id=" + row.id)
      //     .then((data) => {
      //       if (data.code === 200 && data.data) {
      //         this.sonListColumns.columns = this.detailColumns;
      //         this.sonListShow = true;
      //         this.$nextTick(() => {
      //           this.sonList = data.data;
      //         });
      //       } else {
      //         this.$message({message: "获取详情出错", type: "error"});
      //       }
      //     });
      // },
      // 关闭弹框
      clearData() {
        this.fatherVo = [];
        this.listTableData = []
        this.seleckMainGood = {}
        this.combinationModel = {
          type: 10,
          fatherVo: {},
          sonVoList: [],
          combinationType: 10
        };
        this.dialogVisibility = false;
      },
      fatherName(row) {
        return `<span>${row.goodsName}/${row.barCode}</span>`;
      },
      sonName(row) {
        return `<span class="td-click" >${row.sonGoodsName}/${row.sonGoodsNum}个</span>`;
      },

      submitData() {
        if (this.activeName === "first") {
          this.combinationModel.combinationType = 10;//商品组合
        } else if (this.activeName === "second") {
          this.combinationModel.combinationType = 20;//大小包装
          this.combinationModel.type = 70;
        } else {
          this.combinationModel.combinationType = 30;//自动转货
          this.combinationModel.type = 30;
        }
        if (this.fatherVo.length === 0) {
          this.$message({message: "请选择父商品", type: "warning"});
          return;
        }
        this.combinationModel.fatherVo = this.fatherVo[0];
        this.combinationModel.sonVoList = this.$refs.listOperation.getTabelData();
        let result = false
        if (this.combinationModel.sonVoList.length === 0) {
          this.$message({message: "请选择子商品", type: "warning"});
          return;
        } else {
          let length = 0;
          this.combinationModel.sonVoList.map(v => {
            if (v.goodsNum === 0) {
              length = length + 1;
            }
          });
          if (length > 0) {
            this.$message({message: '存在数量为0的商品，不能进行保存！', type: 'warning'});
          } else {
            this.saveData();
          }
        }
      },
      saveData() {
        this.$loading({text: '提交中，请稍后。。。'})
        this.$axios[this.combinationModel.id ? "fetchPut" : "fetchPost"](api.archives.combination, this.combinationModel).then((data) => {
          if (data.code === 200 && data.data) {
            // this.$message({
            //   message: this.combinationModel.id ? "编辑成功" : "添加成功！",
            //   type: "success",
            // });
            this.$notify({
              type: "success",
              title: this.combinationModel.id ? "编辑" : "添加" + '操作',
              message: '成功',
              showClose: false,
            });
            this.fatherVo = [];
            this.clearData()
            // this.$refs.listOperation.clearTableData();
            this.combinationModel = {
              type: 10,
              fatherVo: {},
              sonVoList: [],
              combinationType: 10,
            };
            this.dialogVisibility = false;
            if (this.activeName === "first") {
              this.$refs.combinationTable.getTableData();
            } else if (this.activeName === "second") {
              this.$refs.packTable.getTableData();
            } else {
              this.$refs.TransferTable.getTableData();
            }
          } else {
            this.$message({message: data.msg, type: "error"});
          }
        }).finally(() => {
          this.$loading({}).close()
        })
      },
      //商品组合编辑按钮
      updateCombination(row) {
        this.sonListColumns.columns = this.goodsColumns;
        this.$axios.fetchGet(api.archives.combination + "?id=" + row.id)
          .then((data) => {
            if (data.code === 200 && data.data) {
              if (this.activeName === "first") {
                this.dialogTitle = "编辑组合商品";
                this.sonListColumns.hideSum = false
              } else {
                this.dialogTitle = "编辑自动转货商品";
                this.sonListColumns.hideSum = true
              }
              this.dialogVisibility = true;
              this.combinationModel = data.data;
              this.fatherVo = [data.data.fatherVo];
              data.data.sonVoList.map((item) => {
                item.totalPrice = parseFloat(
                  item.buyPrice * item.goodsNum
                ).toFixed(2);
              });
              this.$nextTick(() => {
                this.$refs.listOperation.addMoreRow(data.data.sonVoList, 0);
              });
            } else {
              this.$message({message: "获取详情出错", type: "error"});
            }
          });
      },
      // 点击大小包装编辑
      updatePack(row) {
        this.sonListColumns.columns = this.bigColumns;
        this.$axios
          .fetchGet(api.archives.combination + "?id=" + row.id)
          .then((data) => {
            if (data.code === 200 && data.data) {
              this.dialogVisibility = true;
              this.combinationModel = data.data;
              this.fatherVo = [data.data.fatherVo];
              this.dialogTitle = "编辑大小包装商品";
              this.sonListColumns.hideSum = false
              data.data.sonVoList.map((item) => {
                item.totalPrice = parseFloat(
                  item.buyPrice * item.goodsNum
                ).toFixed(2);
              });
              this.$nextTick(() => {
                this.$refs.listOperation.addMoreRow(data.data.sonVoList, 0);
              });
            } else {
              this.$message({message: "获取详情出错", type: "error"});
            }
          });
      },
      queryGoodsByBarCode(param, index) {
        if (param.barCode) {
          this.otherParam.barCode = param.barCode;
        } else {
          this.otherParam.barCode = ''
        }
        // this.otherParam.openCombination = 0;
        // this.otherParam.containSonGoods = true;
        if (this.activeName === 'first') { //组合商品
          this.otherParam.sonGoodsType = 1;
        } else if (this.activeName === 'second') {//大小包装
          this.otherParam.sonGoodsType = 1;
        } else {//自动转货
          this.otherParam.sonGoodsType = 2;
        }
        this.$axios.fetchPost('/api/eros/as/asGoods/specs', this.otherParam).then(data => {
          if (data.code === 200) {
            if (data.data) {
              // 判断是否重复
              if (this.$refs['listOperation'].getTabelData().length > 0) {
                let arr = this.fatherVo.concat(this.$refs['listOperation'].getTabelData())
                let result = arr.some(v => {
                  return v.goodsId === data.data.goodsId
                })
                if (result) {//如果已经存在
                  this.$message({message: '该商品已被选择！', type: 'warning'});
                  this.$refs['listOperation'].setColumnData([], index);
                } else {
                  this.$refs['listOperation'].setColumnData(data.data, index);
                }
              } else {
                this.$refs['listOperation'].setColumnData(data.data, index);
              }
            } else {
              this.$message({message: '无对应商品！', type: 'warning'});
              this.$refs['listOperation'].setColumnData([], index);
            }
          } else {
            this.$message({message: '请求失败！', type: 'error'});
          }
        }).catch(() => {
        });
        this.otherParam.barCode = null;
        this.otherParam.sonGoodsType = null;
      },
      //添加按钮
      addCombination() {
        this.dialogTitle = "添加组合商品";
        this.dialogVisibility = true;
        this.sonListColumns.columns = this.goodsColumns;
        this.sonListColumns.hideSum = false
      },
      addPack() {
        this.dialogTitle = "添加大小包装商品";
        this.dialogVisibility = true;
        this.sonListColumns.columns = this.bigColumns;
        this.sonListColumns.hideSum = false
      },
      addTransfer() {
        this.dialogTitle = "添加自动转货商品";
        this.dialogVisibility = true;
        this.sonListColumns.columns = this.goodsColumns;
        this.sonListColumns.hideSum = true
      },
      //选择商品 多行
      rowsSelectSubmit(rows) {
        this.listShow = false;
        let tableList = this.$refs['listOperation'].getTabelData();
        this.$refs['listOperation'].addMoreRow(rows, tableList.length);
        // this.$refs.listOperation.addMoreRow(rows, 0);
      },
      //选择商品 点击单行
      rowSelectSubmit(row) {
        this.listShow = false;
        if (this.listType == "sonVoList") {
          this.$refs.listOperation.addMoreRow([row], 0);
        } else {
          this.fatherVo = [row];// 所选择的主商品列表
          this.seleckMainGood = row
        }
      },
      // 选择主商品
      showGoodsList() {
        if (this.activeName === 'first') { //组合商品
          this.otherParam.fatherGoodsType = 1;
        } else if (this.activeName === 'second') {//大小包装
          this.otherParam.fatherGoodsType = 1;
        } else {//自动转货
          this.otherParam.fatherGoodsType = 2;
        }
        this.otherParam.openSpecs = false;
        this.listType = "fatherVo";
        this.listShow = true;
        this.$nextTick(() => {
          this.$refs.goodsListOperation.getTableData();
          this.otherParam.fatherGoodsType = null;
        });
        this.$refs.listOperation.clearTableData();
      },
      // 子商品 点击三个点 选择商品
      showSonGoodsList() {
        if (this.activeName === 'first') { //组合商品
          this.otherParam.sonGoodsType = 1;
        } else if (this.activeName === 'second') {//大小包装
          this.otherParam.sonGoodsType = 1;
        } else {//自动转货
          this.otherParam.sonGoodsType = 2;
        }
        this.listType = "sonVoList";
        this.listShow = true;
        this.listTableData = this.$refs["listOperation"].getTabelData()//table数据
        this.$nextTick(() => {
          this.$refs.goodsListOperation.getTableData();
          this.otherParam.sonGoodsType = null;
        });
      },
      typeChange(value) {
        if (this.combinationModel.id) return;
        this.combinationModel.type = value;
      },
      combinationSearchSubmit(param) {
        this.childrenTable = []
        this.$refs["combinationTable"].searchSubmit(param);
      },
      TransferSearchSubmit(param) {
        this.childrenTable = []
        this.$refs["TransferTable"].searchSubmit(param);
      },
      clearSearch(type) {
        if (type == 'combination') {
          this.$refs["combinationTable"].clearSearch();
        } else if (type == 'combination') {
          this.$refs["packTable"].clearSearch();
        } else {
          this.$refs["TransferTable"].clearSearch();
        }
      },
      // 操作回调
      btnCommon(btnObj, data) {
        btnObj.callback && btnObj.callback(data);
      },
      packSearchSubmit(param) {
        this.childrenTable = []
        this.$refs["packTable"].searchSubmit(param);
      },
      numChange(row, index) {
        row.totalPrice = parseFloat(row.buyPrice * row.goodsNum).toFixed(2);
        this.$refs.listOperation.setCountData(row, index);
      },
      getTotalPrice(row, index) {
        row.totalPrice = parseFloat(row.buyPrice * row.goodsNum).toFixed(2);
      },
    },
  };
</script>
<style scoped>
  .combination-page {
    padding-top: 0;
  }

  .combination-page .type-box {
    margin-left: -5px;
    margin-right: -5px;
    display: flex;
    flex-flow: row wrap;
    justify-content: flex-start;
    padding-left: 10px;
    margin-bottom: 10px;
  }

  .combination-page .type-box .type-item {
    padding-left: 5px;
    padding-right: 5px;
    margin-bottom: 5px;
    margin-right: 10px;
    color: #000;
    border: 1px solid #000;
    background: #fff;
    display: block;
    box-sizing: border-box;
    width: 16%;
    text-align: center;
    height: 94px;
  }

  .combination-page .type-box .type-item.active {
    color: #009afe;
    border: 1px solid #009afe;
  }

  .combination-page .type-box .type-item.disabled {
    color: #ccc;
    border: 1px solid #ccc;
  }

  .combination-page .type-box .type-item.disabled.active {
    color: rgb(85, 84, 84);
    border: 1px solid rgb(85, 84, 84);
  }

  .combination-page .type-box .type-title {
    margin-bottom: 9px;
    margin-top: 16px;
    font-size: 16px;
  }

  .combination-page .com-item {
    margin-bottom: 15px;
  }

  .title-combination {
    background-color: #f0f0f0;
    padding: 10px 20px;
    margin: 20px 0 10px 0;
    font-weight: 700;
  }

  .childrenShow {
    margin-bottom: 30px;
  }

  >>> .el-table .cell {
    height: 33px;
    line-height: 33px;
  }

  /deep/ .synchronized {
    min-width: 640px;
    text-align: center;
  }

  /deep/ .importDialog {
    min-width: 640px;
    width: 640px;
    text-align: center;
  }

  /deep/ .el-step__title.is-process {
    color: #458CFF;
  }

  /deep/ .el-step__head.is-process {
    color: #458CFF;
    border-color: #458CFF;
  }
</style>



// WEBPACK FOOTER //
// src/page/archives/goods/Combination.vue